<template>
    <div ref="indexBox">
        <div ref="indexBg" class="index page">
            <div ref="btnBox" class="btnbox">
                <img ref="startBtn" src="" class="startbtn" @click="startClick"/>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/js/utils'

export default {
    data() {
        return {
            isX: false
        }
    },
    mounted() {
        this.postEvent("indexPage");
        this.isX = window.iphone8;
        this.$refs.indexBox.style.height = window.innerHeight + 'px';

        let pagemeta = this.pagemeta.indexPage;
        if (this.isX && pagemeta.bgurlx) {
            pagemeta.bgurl = pagemeta.bgurlx;
            pagemeta.bgheight = pagemeta.bgheightx;
        }
        if (pagemeta.bgcolor) {
            this.$refs.indexBox.style.backgroundColor = pagemeta.bgcolor;
        }
        if (pagemeta.bgurl) {
            this.$refs.indexBg.style.backgroundImage = `url('${pagemeta.bgurl}')`;
            window.indexBg = this.$refs.indexBg;
            console.log('bgurl', pagemeta.bgurl)
        }
        if (pagemeta.bgheight) {
            this.$refs.indexBg.style.backgroundSize = `100% ${utils.rem2px(pagemeta.bgheight)}px`;
        }
        if (pagemeta.btnurl) {
            this.$refs.startBtn.src = pagemeta.btnurl;
        }
    },
    methods: {
        startClick() {
            this.playBgAudio();
            this.$router.replace({
                name: "question"
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';
.index{
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    .btnbox{
        position: fixed;
        text-align: center;
        width: 100%;
        height: 100%;
        left: 0;
        bottom: 0;
        .startbtn {
            display: inline-block;
            width: 100%;
            height: 100%;
        }
    }
}

.page {
    background-position: top center;
    background-repeat: no-repeat;
}
</style>